import uiUtils from "./uiUtils";

const fixedProviders = [
  'GOOGLE',
  'FACEBOOK',
  'YELP',
  'BING'
];

//TODO make array [{matchKey: 'id', matches: ['GOOGLE', 'BING', 'YELP' ]}, { matchKey: 'dashboardSettings', matches: ['reviewRatings', 'reviewResponses', 'reviews']}]
const categoryToProviderFilter = {
  reviews: { matchKey: 'dashboardSettings', matches: ['reviewRatings', 'reviewResponses', 'reviews']},
  listings: { matchKey: 'dashboardSettings', matches: ['listings'] },
  rankings: { matchKey: 'id', matches: ['GOOGLE', 'BING', 'YELP' ] }
};

export default {
  isFixedProvider: (providerId) => {
    return fixedProviders.indexOf(providerId) === -1;
  },
  filteredProviders: (typeCategory, providersArray, providersHash, selectedVertical, availableVerticals) => {
    const verticalsProviderHash = {};
    availableVerticals.filter(v => selectedVertical.indexOf(v._id) !== -1).forEach(v => {
      v.providers.forEach(providerId => verticalsProviderHash[providerId] = providersHash[providerId]);
    });
    const matcher = categoryToProviderFilter[typeCategory.category];
    return providersArray
      .filter(provider => verticalsProviderHash[provider.id])
      .filter(provider => {
        let field = provider[matcher.matchKey];
        let check = typeof field;
        //not ideal, but dynamically match against a field in provider
        let hasMatch = false;
        for(let i = 0; i < matcher.matches.length; i++) {
          let match = matcher.matches[i];
          if (check === 'object' && Array.isArray(field)) {
            hasMatch = (field.indexOf(match) === -1);
          } else if (check === 'object') {
            hasMatch = field[match];
          }else {
            hasMatch = (field === match);
          }
          if (hasMatch) break;
        }
        return hasMatch;
      });
  }
}
